import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useCMSContent } from '../hooks/useCMSContent';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  
  // Fetch CMS content
  const { data: companyInfo } = useCMSContent('companyInfo');

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/owners', label: 'For Owners' },
    { path: '/tenants', label: 'For Tenants' },
    { path: '/about', label: 'About Us' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header style={{
      backgroundColor: 'white',
      borderBottom: '1px solid var(--border-light)',
      position: 'sticky',
      top: 0,
      zIndex: 50,
      boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
    }} data-testid="header">
      <div className="container" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '18px 40px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {/* Logo */}
        <Link to="/" style={{ textDecoration: 'none' }}>
          <h1 style={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 700,
            fontSize: '1.4rem',
            color: 'var(--text-primary)',
            margin: 0,
            letterSpacing: '-0.01em'
          }}>
            {companyInfo?.companyName || 'Laurel Run Management Group'}
          </h1>
        </Link>

        {/* Desktop Navigation */}
        <nav style={{ display: 'none' }} className="desktop-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              style={{
                color: isActive(link.path) ? 'var(--brand-primary)' : 'var(--text-secondary)',
                textDecoration: 'none',
                fontFamily: 'Inter, sans-serif',
                fontSize: '0.9375rem',
                fontWeight: isActive(link.path) ? 600 : 500,
                padding: '0.5em 1em',
                transition: 'color 0.2s ease',
                position: 'relative'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => !isActive(link.path) && (e.target.style.color = 'var(--text-secondary)')}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          style={{
            display: 'none',
            background: 'transparent',
            border: 'none',
            color: 'var(--text-primary)',
            cursor: 'pointer',
            padding: '8px'
          }}
          className="mobile-menu-btn"
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <nav style={{
          display: 'none',
          flexDirection: 'column',
          backgroundColor: 'white',
          padding: '20px',
          borderTop: '1px solid var(--border-light)',
          boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
        }} className="mobile-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMobileMenuOpen(false)}
              style={{
                color: isActive(link.path) ? 'var(--brand-primary)' : 'var(--text-secondary)',
                textDecoration: 'none',
                fontFamily: 'Inter, sans-serif',
                fontSize: '1rem',
                fontWeight: isActive(link.path) ? 600 : 500,
                padding: '1em',
                borderBottom: '1px solid var(--border-light)',
                transition: 'color 0.2s ease'
              }}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      )}

      <style>{`
        @media (min-width: 769px) {
          .desktop-nav {
            display: flex !important;
            gap: 0.5rem;
            align-items: center;
          }
          .mobile-menu-btn {
            display: none !important;
          }
        }
        
        @media (max-width: 768px) {
          .mobile-menu-btn {
            display: block !important;
          }
          .mobile-nav {
            display: flex !important;
          }
        }
      `}</style>
    </header>
  );
};
